import { LocationInfo } from './models/location-info.model';

export const RESOLVE_KEY = 'geolocationData';
export const ACCOUNT_COUNTRY_HEADER = 'x-i2g-account-country';

export interface IGeolocationDataResolveData {
  locationInfo: LocationInfo;
}

export enum AddressDataStatesEnum {
  no_match = 'no_match',
  success = 'success',
  skipped = 'skipped',
}
